import React, { ChangeEvent, FunctionComponent, Key, useEffect, useState } from 'react';
import { Input, InputNumberProps } from 'antd';
import { getNonNaNFloatValue, getNonNaNNumberValue } from '../../../utils';

interface Props extends Omit<InputNumberProps, 'onInput'> {
  value?: string | number;

  isValid?(value: string): boolean;

  onChange?(value?: Key | null): void;
}

const NUMBER_REGEXP = /^-?\d*(\.\d*)?$/;
const INTEGER_REGEXP = /^\d*?$/;

export const InputNumber: FunctionComponent<Props> = ({ isValid, ...props }) => {
  const [valueState, setValueState] = useState('');

  useEffect(() => {
    if ((props.value || props.value === 0) && props.onChange) {
      const numberValue = typeof props.value === 'string' ? parseFloat(props.value) : props.value;
      const stringValue = numberValue.toString();
      setValueState(stringValue);
      props.onChange(getNonNaNFloatValue(stringValue));
    }
  }, [props.value]);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const numberValue = parseFloat(value);
    if ((!isNaN(numberValue) && NUMBER_REGEXP.test(value)) || value === '' || value === '-') {
      if (isValid) {
        if (isValid(value)) {
          if (props.onChange) {
            props.onChange(getNonNaNFloatValue(value));
          }
          setValueState(value);
        }
      } else {
        if (props.onChange) {
          props.onChange(getNonNaNFloatValue(value));
        }
        setValueState(value);
      }
    } else {
      if (props.onChange) {
        props.onChange(getNonNaNFloatValue(valueState ?? ''));
      }
      setValueState(valueState);
    }
    if (value === '0') {
      if (props.onChange) {
        props.onChange('0');
      }
      setValueState('0');
    }
  };

  return <Input {...props} value={valueState} onChange={onChange} />;
};

export const InputInteger: FunctionComponent<Props> = ({ isValid, ...props }) => {
  const [valueState, setValueState] = useState('');

  useEffect(() => {
    if ((props.value || props.value === 0) && props.onChange) {
      const numberValue = typeof props.value === 'string' ? parseFloat(props.value) : props.value;
      const stringValue = numberValue.toString();
      setValueState(stringValue);
      props.onChange(getNonNaNNumberValue(stringValue));
    }
  }, [props.value]);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const numberValue = parseFloat(value);
    if ((!isNaN(numberValue) && INTEGER_REGEXP.test(value)) || value === '') {
      if (isValid) {
        if (isValid(value)) {
          if (props.onChange) {
            props.onChange(getNonNaNFloatValue(value));
          }
          setValueState(value);
        }
      } else {
        if (props.onChange) {
          props.onChange(getNonNaNFloatValue(value));
        }
        setValueState(value);
      }
    } else {
      if (props.onChange) {
        props.onChange(getNonNaNFloatValue(valueState ?? ''));
      }
      setValueState(valueState);
    }
    if (value === '0') {
      if (props.onChange) {
        props.onChange('0');
      }
      setValueState('0');
    }
  };

  return <Input {...props} value={valueState} onChange={onChange} />;
};
